import { Card, CardContent, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import './CustomerDashboardCards.css';
import { getCustomerCardData } from '../dashboardUtilts';


const CustomerDashboardCards = ({ customer }) => {
  const cardData = getCustomerCardData(customer);

  return (
    <Box className="dashboard-card-wrapper">
      {cardData.map((item, i) => (
        <div key={i} className="dashboard-grid-item">
          <Card className="dashboard-card">
            <CardContent className="dashboard-card-content">
              <div className="dashboard-card-header">
                {item.icon && <span className="dashboard-card-icon">{item.icon}</span>}
                <Typography variant="body2" className="dashboard-card-title" style={{ fontSize: '0.7rem' }}>
                  {item.title}
                </Typography>
              </div>
              <Typography variant="h6" className="dashboard-card-value">
                {item.animate ? (
                  <CountUp
                    end={typeof item.value === 'number' ? item.value.toLocaleString('en-IN') : 0}
                    duration={2}
                    separator=","
                  />
                ) : item.animateDate ? (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                  >
                    {item.value}
                  </motion.div>
                ) : (
                  item.formatter ? item.formatter(item.value) : item.value
                )}
              </Typography>
            </CardContent>
          </Card>
        </div>
      ))}
    </Box>
  );
};

export default CustomerDashboardCards;
